module.exports = __webpack_public_path__ + "img/sameah_yes.10d874f0.png";